import { carouselItems } from '@/mocks/homeData';

export default function SectionCarousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">焦点专题</span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">深度专题</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-xl mx-auto">高清影视在线观看深度内容策划，发现更多精彩</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item, idx) => (
            <div key={idx} className="group cursor-pointer bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-colors">
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-2 mb-3">
                  <span className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">{item.category}</span>
                  <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">{item.tag}</span>
                </div>
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.summary}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}